<template>

  <b-row>

    <b-col cols="12" md="6">
      <div class="imgsWrapper">
        <ShoeImgs :pair="votePair.pair"/>
      </div>
    </b-col>
    <b-col cols="12" md="6">
      <div>
        <div class="nav">
          <ul>
            <li v-for="t in tabs" :key="t.name" :class="tabNavClass(t.name)" @click="tabClick(t.name)">{{
                t.label
              }}
            </li>
          </ul>
        </div>
        <div class="tab">
          <TabSingle v-if="tabActive==='ispair'"
                     :vote-group="votePair.vote.groups.ispair"
                     :values="values.ispair"
                     :question="questions.ispair"
                     :tooltip="tooltips.ispair"
                     @tabComplete="tabCompleted"
                     key="0"></TabSingle>
          <TabSingle v-if="tabActive==='aisleft'"
                     :vote-group="votePair.vote.groups.aisleft"
                     :values="values.aisleft"
                     :question="questions.aisleft"
                     :tooltip="tooltips.aisleft"
                     @tabComplete="tabCompleted"
                     key="1"></TabSingle>
          <TabSingle v-if="tabActive==='sex'"
                     :vote-group="votePair.vote.groups.sex"
                     :values="values.sex"
                     :question="questions.sex"
                     :tooltip="tooltips.sex"
                     @tabComplete="tabCompleted"
                     key="2"></TabSingle>
          <TabSingle v-if="tabActive==='age'"
                     :vote-group="votePair.vote.groups.age"
                     :values="values.age"
                     :question="questions.age"
                     :tooltip="tooltips.age"
                     @tabComplete="tabCompleted"
                     key="3"></TabSingle>
          <TabSingle v-if="tabActive==='season'"
                     :vote-group="votePair.vote.groups.season"
                     :values="values.season"
                     :question="questions.season"
                     :tooltip="tooltips.season"
                     @tabComplete="tabCompleted"
                     key="4"></TabSingle>
          <TabSingle v-if="tabActive==='size'"
                     :vote-group="votePair.vote.groups.size"
                     :values="values.size"
                     :question="questions.size"
                     :tooltip="tooltips.size"
                     @tabComplete="tabCompleted"
                     key="5"></TabSingle>
          <TabSingle v-if="tabActive==='soletype'"
                     :vote-group="votePair.vote.groups.soletype"
                     :values="values.soletype"
                     :question="questions.soletype"
                     :tooltip="tooltips.soletype"
                     @tabComplete="tabCompleted"
                     key="6"></TabSingle>
          <TabMulti v-if="tabActive==='lock'"
                    :vote-group="votePair.vote.groups.lock"
                    :values="values.lock"
                    :question="questions.lock"
                    :tooltip="tooltips.lock"
                    @tabComplete="tabCompleted"
                    key="7"></TabMulti>
          <TabMulti v-if="tabActive==='style'"
                    :vote-group="votePair.vote.groups.style"
                    :values="values.style"
                    :question="questions.style"
                    :tooltip="tooltips.style"
                    @tabComplete="tabCompleted"
                    key="8"></TabMulti>
          <TabSingle v-if="tabActive==='condition'"
                     :vote-group="votePair.vote.groups.condition"
                     :values="values.condition"
                     :question="questions.condition"
                     :tooltip="tooltips.condition"
                     @tabComplete="tabCompleted"
                     key="9"></TabSingle>
        </div>
      </div>
    </b-col>

  </b-row>
</template>

<script>

import TabSingle from "@/components/TabSingle";
import TabMulti from "@/components/TabMulti";
import {questions, tabs, values, tooltips} from "@/props";

import ShoeImgs from "@/components/ShoeImgs";


export default {
  name: 'vote',
  components: {ShoeImgs, TabMulti, TabSingle},
  props: ["votePair"],
  data: function () {
    return {
      tabActive: "ispair",
      tabs: tabs,
      questions: questions,
      values: values,
      tooltips: tooltips,
      others: ["aisleft", "sex", "age", "season", "size", "soletype", "lock", "style", "condition"]
    }
  },
  created() {
    this.tabActive = this.findFirstTabIncomplete();
  },
  methods: {
    tabNavClass(tab) {
      let status = this.votePair.vote.groups[tab].status;
      return {
        disabled: this.tabDisabled(tab),
        enabled: status === "TODO",
        completed: status === "DONE" || status === "CANT" || status === "DKNO",
        active: this.tabActive === tab,
        clickable: !this.tabDisabled(tab)
      }
    },
    tabDisabled(tab) {
      let status = this.votePair.vote.groups[tab].status;
      return !!(this.others.includes(tab) && this.pairNegative() || status === "NONE");
    },
    pairPositive() {
      return this.votePair.vote.groups.ispair.values.ispair === "YES"
    },
    pairNegative() {
      let votedNo = this.votePair.vote.groups.ispair.values.ispair === "NO"
      let votedCantTell = this.votePair.vote.groups.ispair.status === "CANT"
      let votedDontKnow = this.votePair.vote.groups.ispair.status === "DKNO"
      return votedNo || votedCantTell || votedDontKnow
    },
    tabClick(tab) {
      if (!this.tabDisabled(tab))
        this.tabActive = tab
    },
    tabCompleted(tab) {
      if (tab === "ispair") {
        for (let other of this.others) {
          if (this.votePair.vote.groups[other].status === "TODO" && this.pairNegative())
            this.votePair.vote.groups[other].status = "WONT"
          if (this.votePair.vote.groups[other].status === "WONT" && this.pairPositive())
            this.votePair.vote.groups[other].status = "TODO"
        }
      }
      let next = this.findFirstTabIncomplete()
      if (next !== null)
        this.tabActive = next
      else
        this.$emit("voteComplete", this.votePair)
    },
    isTabCompleted(tab) {
      return this.votePair.vote.groups[tab].status !== "TODO"
    },
    findFirstTabIncomplete() {
      for (let tab of Object.keys(this.values)) {
        if (!this.isTabCompleted(tab))
          return tab
      }
      return null
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.disabled {
  color: #9b7e5b !important;
}

.enabled {
  color: #F2AD46
}

.completed {
  color: white;
}

.active {
  border: 1px solid black;
  border-radius: 15px;
  color: black !important;
}

.clickable {
  cursor: pointer
}

li {
  display: inline-block;
  padding: 1em;
}

ul {
  padding: 0
}

.imgsWrapper{
  height: calc(100vh - 108px);
}
.actions {
  margin: 1em;
  min-width: 300px;
}

</style>
